export const GETGOODSLOCATIONLIST = 'GETGOODSLOCATIONLIST' // 获取货位信息列表
export const SAVEGOODSLOCATION = 'SAVEGOODSLOCATION' // 保存
export const DELGOODSLOCATION = 'DELGOODSLOCATION' // 删除
export const IMPORTGOODSLOCATION = 'IMPORTGOODSLOCATION'//  导入
export const GETGOODSLOCATIONDETAILS = 'GETGOODSLOCATIONDETAILS' // 获取货位详情



// WEBPACK FOOTER //
// ./src/store/goodsLocation/types.js